'use client'

import React, { useEffect } from 'react'
import { Link } from '@/lib'
import { Button } from '@/components/ui/button'
import { SignOut } from 'phosphor-react'
import Components from '../components'
import { useAuth } from '../contexts/AuthContext'

export default function GlassNavigation() {
  const { logout, isAuthenticated } = useAuth()
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const linkClass =
    'text-[var(--brutal-ink)] hover:bg-[var(--brutal-mustard)] hover:text-[var(--brutal-ink)] border-0 rounded-[10px] font-semibold transition-all duration-120 px-2 lg:px-3'

  return (
    <>
      <nav
        className="mobile-header md:fixed md:top-0 md:left-0 md:right-0 md:z-50 md:p-6 transition-opacity duration-200"
        role="navigation"
        aria-label="Main navigation"
        style={{ paddingRight: 'calc(1.5rem + 12px)' }}
      >
        <div className="max-w-7xl mx-auto">
          <div className="brutal-panel px-3 md:px-6 py-2 md:py-4 bg-[var(--brutal-panel)]">
            <div className="flex items-center justify-between">
              <Link 
                to="/Home" 
                className="flex items-center space-x-2 md:space-x-3 hover:opacity-80 transition-opacity duration-200"
                onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
              >
                <img 
                  src="https://wemxiqpkiyrwpffrdrgu.supabase.co/storage/v1/object/public/public-assets/projects/c0329852-5824-4c56-b2fb-026919af3589/a449770d-d689-4eef-b810-94ffbacd1921.jpeg" 
                  alt="Dixon Bordiano" 
                  className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover object-center border-2 border-[var(--brutal-ink)] shadow-[var(--brutal-shadow-sm)]"
                  loading="eager"
                />
                <div className="text-[var(--brutal-ink)] min-w-0 flex-1 max-h-[3.75rem] overflow-hidden flex flex-col">
                  <div className="font-bold text-sm md:text-base leading-tight line-clamp-2 flex-shrink-0 tracking-tight">
                    Dixon Bordiano
                  </div>
                  <div className="brutal-label mt-0.5 line-clamp-1 flex-shrink-0 normal-case tracking-normal">
                    Creative & Product Design Leader
                  </div>
                </div>
              </Link>
              
              <div className="hidden md:flex items-center space-x-1.5 lg:space-x-2">
                <Button asChild variant="ghost" size="sm" className={linkClass}>
                  <Link to="/Home">Home</Link>
                </Button>
                <Button asChild variant="ghost" size="sm" className={linkClass}>
                  <Link to="/CreativeProjects">Creative</Link>
                </Button>
                <Button asChild variant="ghost" size="sm" className={linkClass}>
                  <Link to="/ProfessionalProjects">Product & Design</Link>
                </Button>
                {isAuthenticated && (
                  <>
                    <Button asChild variant="ghost" size="sm" className={linkClass}>
                      <Link to="/Process">Process</Link>
                    </Button>
                    <Button asChild variant="ghost" size="sm" className={linkClass}>
                      <Link to="/About">About</Link>
                    </Button>
                  </>
                )}
                <Button asChild variant="ghost" size="sm" className={linkClass}>
                  <Link to="/Contact">Contact</Link>
                </Button>
                {isAuthenticated && (
                  <Button 
                    onClick={logout}
                    variant="ghost" 
                    size="sm"
                    className={`${linkClass} text-[var(--brutal-accent)] hover:bg-[var(--brutal-kraft)] ml-1.5 lg:ml-2`}
                  >
                    <SignOut weight="duotone" className="w-4 h-4 mr-1 lg:mr-2" />
                    <span className="hidden lg:inline">Logout</span>
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
      
      <Components.MobileNavigation />
    </>
  )
}
